import axios from './index';

class PinCodeApi {
  static Get = (data) => {
    // console.log(data);
    return axios.get(`${base}/${data.pincode}`);
  };
}

let base = 'comm/pincode';

export default PinCodeApi;
